module.exports = __webpack_public_path__ + "img/logo.81aa85f.png";